import React from "react";

import styled from "styled-components";
import { Button } from "antd";

const ButtonStyle = styled.div`
    min-width: 39px;
    height: 39px;
    display: inline-block;
`;

const Icon = ({
    icon,
    children,
    ...otherProps
}: {
    icon: string;
    children?: React.Component;
}) => (
    <ButtonStyle>
        <Button icon={icon} {...otherProps}>
            {children}
        </Button>
    </ButtonStyle>
);

export default Icon;
